import Vue from 'vue'
import VueRouter from 'vue-router' 

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    meta: { title: process.env.VUE_APP_TITLE + ' - 登陆' ,unRequireAuth:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/main/login_new.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: { title: process.env.VUE_APP_TITLE + ' - 注册' ,unRequireAuth:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/main/register.vue')
  },
  {
    path: '/find',
    name: 'find',
    meta: { title: process.env.VUE_APP_TITLE + ' - 找回密码' ,unRequireAuth:true},
    component: () => import(/* webpackChunkName: "about" */ '../views/main/find.vue')
  },
  {
    path: '/form',
    name: 'form',
    meta: { title: process.env.VUE_APP_TITLE + ' - 参赛形式'},
    component: () => import(/* webpackChunkName: "about" */ '../views/main/form.vue')
  },  
  {
    path: '/',
    name: 'Index',
    meta: { title: process.env.VUE_APP_TITLE + ''},
    component: () => import(/* webpackChunkName: "about" */ '../views/main/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
 
// 根据路由设置标题
router.beforeEach((to, from, next) => {
  //404重定向登录页面
  if (to.matched.length === 0) {
    // window.location.href = "/report/login"
  }
  /*路由发生改变修改页面的title */
  if (to.meta.title) {
    document.title = to.meta.title
  } 
  next();
})

export default router
